/** Shared React Query options for Pipeline Observability Dashboard. */
const FIVE_MINUTES_MS = 5 * 60_000;

export const PIPELINE_QUERY_OPTIONS = {
  refetchInterval: FIVE_MINUTES_MS,
  refetchIntervalInBackground: false,
  staleTime: FIVE_MINUTES_MS - 5_000,
  cacheTime: 10 * 60_000,
  refetchOnWindowFocus: false,
  retry: 1
} as const;
